export const selectSearchResult = (state) => state.searchResult;
export const selectSearchKey = (state) => state.searchKey;
